import React from "react";
import {connect} from "react-redux";
import Settings from "./Settings";
import {setThemeIsDark} from "../../Redux/appReducer";
import {compose} from "redux";
import withRedirect from "../../Utilits/Redirect";
import {setActivePageSite} from "../../Redux/authReducer";



class SettingsContainer extends React.Component {
    componentDidMount() {
        this.props.setActivePageSite("SETTINGS")
    }

    render() {
        return(
            <Settings setThemeIsDark={this.props.setThemeIsDark} themeIsDark={this.props.themeIsDark}/>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        themeIsDark: state.appReducer.themeIsDark
    }
};

export default compose(
    connect(mapStateToProps, {setThemeIsDark, setActivePageSite}),
    withRedirect
)(SettingsContainer)